import { render, staticRenderFns } from "./InterviewDetails.vue?vue&type=template&id=85cef1ee&scoped=true"
import script from "./InterviewDetails.vue?vue&type=script&lang=js"
export * from "./InterviewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cef1ee",
  null
  
)

export default component.exports